import { Button, Card, CardContent, Grid, TextField } from "@material-ui/core";
import axios from "axios";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { authToken } from "../components/Authentication";
import { BackendURL } from "../globals";
import { ProjectExtended } from "./ProjectEditDialog"; //TODO decouple
import analytics from "../analytics";

export default function DomainsPage(props: { project: ProjectExtended }) {
  const { register, handleSubmit } = useForm();
  const apiRoot = `${BackendURL}/api`;

  axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;

  async function submitForm(data: any) {
    await axios.put(`${apiRoot}/projects/${props.project.name}/`, data);
  }

  useEffect(() => {
    analytics.page("Domains");
  }, []);

  return (
    <>
      <Card variant="outlined">
        <CardContent>
          <form onSubmit={handleSubmit(submitForm)}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Certificate ARN"
                  name="acm_certificate_arn"
                  defaultValue={props.project.acm_certificate_arn}
                  variant="filled"
                  fullWidth
                  inputRef={register}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Certificate ARN in Virginia (needed for CloudFront)"
                  name="acm_certificate_arn_virginia"
                  defaultValue={props.project.acm_certificate_arn_virginia}
                  variant="filled"
                  fullWidth
                  inputRef={register}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Zone ID (optional; to automatically manage subdomains)"
                  name="r53_zone_id"
                  defaultValue={props.project.r53_zone_id}
                  variant="filled"
                  fullWidth
                  inputRef={register}
                />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="secondary">
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </>
  );
}
